<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-17 12:30:46
 * @LastEditTime: 2019-10-09 22:08:07
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="storeDetail container">
        <ul>
            <!-- <li>门店图片: <img :src="detail.domain_name+detail.img_url[0]" alt=""></li> -->
            <li>经销商编号: <span>{{detail.dealer_sn}}</span></li>
            <li>经销商名称: <span>{{detail.dealer_name}}</span></li>
            <li>经销商级别: <span>{{detail.lname}}</span></li>
            <li>销售地区: <span>{{detail.region_list}}</span></li>
            <li>经销商地址:<span>{{detail.person}}</span> </li>
            <li>手机号码: <span>{{detail.mobile}}</span></li>
            <li>上级经销商:<span>{{detail.parent_dealer_name}}</span></li>
            <!-- <li>可访问国家地区: <span>{{detail.mobile}}</span></li> -->
            <li>添加时间: <span>{{detail.addtime}}</span></li>
            <li>简介: <span>{{detail.msg}}</span></li>

        </ul>
    </div>
</template>

<script>
export default {
    name:'detail',
    data(){
        return{
            detail:{}
        }
    },
    methods:{
        getDetail(){
            this.$get('logistics_2','/vstore/dealer_pc/dealerdetail',{
                id:this.$route.query.id
            }).then(res=>{
                this.detail=res.data
            })
        }
    },
    
    created(){
        this.getDetail()
    }
}
</script>>

<style lang="scss" scoped>
ul{
    padding: 40px 50px;
    li{
            color: #666;
    list-style: none;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    img{
        width: 10%;
        margin-left: 10px;
    }
    span{
        margin-left: 10px;
    }
    }
}
</style>